import { SearchBarCore } from './SearchBarCore';

/** Shell / header compact search — same engine as Explore & Questions */
export function GlobalSearch(props: { className?: string; placeholder?: string }) {
  return <SearchBarCore variant="header" className={props.className} placeholder={props.placeholder} />;
}
